/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pale_Shy_Moth_DriftInputs */

const en_pale_shy_moth_drift = /** @type {(inputs: Pale_Shy_Moth_DriftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No name`)
};

const de_pale_shy_moth_drift = /** @type {(inputs: Pale_Shy_Moth_DriftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Name`)
};

/**
* | output |
* | --- |
* | "No name" |
*
* @param {Pale_Shy_Moth_DriftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pale_shy_moth_drift = /** @type {((inputs?: Pale_Shy_Moth_DriftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pale_Shy_Moth_DriftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pale_shy_moth_drift(inputs)
	return de_pale_shy_moth_drift(inputs)
});